export default "__VITE_ASSET__CVs1TQQW__"